import React from 'react';
import { MessageCircle } from 'lucide-react';
import { heroData } from '../data/mock';

const HeroSection = () => {
  const whatsappLink = `https://wa.me/${heroData.whatsappNumber.replace(/[^0-9]/g, '')}?text=${encodeURIComponent(heroData.whatsappMessage)}`;

  return (
    <section className="min-h-screen flex items-center bg-[#FFFEF8] pt-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 lg:py-24">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          {/* Text Content */}
          <div className="order-2 lg:order-1">
            <p className="text-sm tracking-[0.2em] text-[#6B8F71] mb-6 uppercase">
              {heroData.tagline}
            </p>
            
            <h1 className="text-4xl lg:text-5xl xl:text-6xl font-light text-[#333333] leading-tight mb-8">
              {heroData.headline}
            </h1>
            
            <p className="text-lg text-[#666666] leading-relaxed mb-12 max-w-xl">
              {heroData.description}
            </p>
            
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 px-8 py-4 border border-[#333333] text-[#333333] text-sm font-medium tracking-wide hover:bg-[#333333] hover:text-[#FFFEF8] transition-all duration-300"
            >
              <MessageCircle className="w-5 h-5" />
              {heroData.ctaText}
            </a>
          </div>

          {/* Image */}
          <div className="order-1 lg:order-2">
            <div className="relative">
              <img
                src={heroData.heroImage}
                alt="Crystal healing stones"
                className="w-full h-[400px] lg:h-[550px] object-cover"
              />
              {/* Subtle accent line */}
              <div className="absolute -bottom-4 -right-4 w-24 h-24 border border-[#6B8F71]/30" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
